module.exports = {
  admin: {
    key: 'admin',
    label: 'Admin',
  },
  global: {
    key: 'global',
    label: 'Global',
  },
  org: {
    key: 'org',
    label: 'Organization',
  },
  user: {
    key: 'user',
    label: 'User',
  },
  library: {
    key: 'library',
    label: 'Library',
  },
  eoc: {
    key: 'eoc',
    label: 'Episode of Care',
  },
  team: {
    key: 'team',
    label: 'Team',
  },
};